/**
 * Circle background by rarity (celebration modal + profile).
 * S8-02: darker fills improve contrast with white initials (WCAG for graphical objects).
 */
export function achievementCircleColor(rarity: string): string {
  const r = rarity?.toLowerCase() || '';
  if (r.includes('epic')) return '#5b21b6';
  if (r.includes('rare')) return '#1d4ed8';
  return '#334155';
}
